export enum WidgetsQueries {
  Forecast = 'widgetForecast',
}
